import {
  Action,
  AnyAction,
  combineReducers,
  configureStore,
  ThunkAction,
} from '@reduxjs/toolkit';
import { createWrapper, HYDRATE } from 'next-redux-wrapper';
import { crmSlice } from '../features/crm/crm';
import { infoOrderingReducer } from '../features/infoOrdering/reducer';
import { orderingForSaleSlice } from '../features/sale/sale';
import { orderingForPrePaymentSaleSlice } from '../features/prePaymentSale/prePaymentSale';


const combinedReducer = combineReducers({
  infoOrdering: infoOrderingReducer,
  orderingForSale: orderingForSaleSlice.reducer,
  crm: crmSlice.reducer,
  orderingForPrePaymentSale: orderingForPrePaymentSaleSlice.reducer
});

const reducer = (state: ReturnType<typeof combinedReducer>, action: AnyAction) => {
  if (action.type === HYDRATE) {
    const nextState = {
      ...state, // use previous state
      ...action.payload, // apply delta from hydration
    };
    return nextState;
  } else {
    return combinedReducer(state, action);
  }
};

export const makeStore = () => configureStore({reducer,});

type Store = ReturnType<typeof makeStore>;

export type AppDispatch = Store['dispatch'];
export type RootState = ReturnType<Store['getState']>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export const wrapper = createWrapper(makeStore, { debug: true });